/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {verifyContacts} from '../api'

export const useMutationVerifyContacts = createReactQueryMutationHook('verifyContacts', verifyContacts)
